<script setup lang="ts">
import type { TemplateField } from '../types/entities';
import type { CalendarConfig } from '../lib/calendar';
import { computed } from 'vue';

import StoryTimeFields from './StoryTimeFields.vue';

type TimePoint = { timeBasis?: 'calendar' | 'earth'; absoluteTime?: string | null; calendarParts?: Record<string, string | number | null>; clockLabel?: string | null };
const props = defineProps<{ field: TemplateField; calendar: CalendarConfig; modelValue: unknown; readonly?: boolean }>();
const emit = defineEmits<{ 'update:modelValue': [value: unknown] }>();
function point(value: unknown): TimePoint {
  if (value && typeof value === 'object' && !Array.isArray(value)) return value as TimePoint;
  if (typeof value === 'string' && value) return { timeBasis: 'earth', absoluteTime: value };
  return { timeBasis: 'calendar', calendarParts: {}, clockLabel: null, absoluteTime: null };
}
const single = computed(() => point(props.modelValue));
const range = computed(() => {
  const value = props.modelValue && typeof props.modelValue === 'object' && !Array.isArray(props.modelValue) ? props.modelValue as { start?: unknown; end?: unknown } : {};
  return { start: point(value.start), end: point(value.end) };
});
function updateRange(key: 'start' | 'end', value: TimePoint) { emit('update:modelValue', { ...range.value, [key]: value }); }
</script>
<template>
  <section class="template-time-field">
    <StoryTimeFields v-if="field.kind === 'time-point'" :calendar="calendar" :model-value="single" :readonly="readonly" @update:model-value="emit('update:modelValue', $event)" />
    <template v-else><fieldset><legend>Beginn</legend><StoryTimeFields :calendar="calendar" :model-value="range.start" :readonly="readonly" @update:model-value="updateRange('start', $event)" /></fieldset><fieldset><legend>Ende</legend><StoryTimeFields :calendar="calendar" :model-value="range.end" :readonly="readonly" @update:model-value="updateRange('end', $event)" /></fieldset></template>
  </section>
</template>
